import { PostProcessingOutputItem } from "./PostProcessingOutputItem";
import { PostProcessingOutputType } from "./PostProcessingOutputType";




export class PostProcessingOutput<TItem extends PostProcessingOutputItem> {

    public outputType?: PostProcessingOutputType;
    public outputs?: Array<TItem>;

}